<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <input :type="password ? 'password' : undefined" :class="{ 'input-component': true, 'active': active}" @focus="toggleActive" @blur="toggleActive"  v-model="internalValue" :disabled="disabled"/>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "./FormInputLayout";
    import FormInputMixin from "./FormInputMixin";
    export default {
        name: "FormTextInput",
        components: {FormInputLayout},
        mixins: [FormInputMixin],
        props: {
            helpItemCode: String,
            password: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.input-component {
    border: none;
    border-bottom: 1px solid var(--input-border-color);
    background-color: var(--input-background-color);
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
    font-size: $inputFontSize;
}

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border-bottom: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }
</style>